"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextCell = void 0;
var _react = _interopRequireDefault(require("react"));
var _headerCellFactory = require("../header-cell/headerCellFactory");
var _loadingCellFactory = require("../loading-cell/loadingCellFactory");
var _textCellModule = _interopRequireDefault(require("./text-cell.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var TextCell = function TextCell(_ref) {
  var data = _ref.data,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("td", {
    className: (0, _classnames.default)(_textCellModule.default['text-cell'], className)
  }, data || '-');
};
exports.TextCell = TextCell;
TextCell.Header = (0, _headerCellFactory.headerCellFactory)(_textCellModule.default['text-cell']);
TextCell.Loading = (0, _loadingCellFactory.loadingCellFactory)(_textCellModule.default['text-cell']);